import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { ApplicationClientCommonModule } from '@sdbn/common';

import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { VisitorRegistrationQRCodeComponent } from './visitor-registration-qrcode.component';


import { MatCardModule as MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    VisitorRegistrationQRCodeComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    ApplicationClientCommonModule,
    CommonTranslationModule,
    QRCodeComponent,
    MatCardModule
  ]
})
export class VisitorRegistrationQRCodeModule { }
